interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const PageHeader = ({ title, subtitle, children }: PageHeaderProps) => {
  return (
    <div className="flex flex-col gap-2 mb-8">
      {subtitle ? (
        <>
          <h1 className="text-xl ">{title}</h1>
          <div className="flex justify-between items-center gap-4">
            <h2 className="text-4xl font-bold truncate min-w-0" title={subtitle}>
              {subtitle}
            </h2>
            <div className="shrink-0">{children}</div>
          </div>
        </>
      ) : (
        <>
          <h1 className="text-4xl font-bold">{title}</h1>
          <div className="flex justify-between">{children}</div>
        </>
      )}
    </div>
  );
};
